// extracted by mini-css-extract-plugin
export default {"container":"DIFaEsyR","title":"HNs7mDLL","buttonContainer":"_2KT9RS4f","error":"zqidLj5q"};